import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import {Button,Icon,Input,List,Skeleton} from 'antd';
import {fetchPost,fetchGet} from "../../utils/fetchRequest";
import {API,_baseURL} from "../../configs/api.config";
import {connect} from 'react-redux'
import PhoneInfoItem from './PhoneInfoItem';
import RefreshLayout from "../../components/RefreshLayout";
import {getIntValue, getStrValue, isObjEmpty} from "../../utils/common";
import {Toast} from 'antd-mobile';

let mPageIndex = 0

class PhoneInfo extends Component {
     constructor(props){
         super(props);
         this.state={
             detailVisible: false,
             pageIndex:1,
             pageSize:10,
             listItem:null,
             index:null,
             role:this.props.userInfo.userRole,
             data:[],
             isRefreshing: false,
             isLoading: true
         };
     }

     componentWillMount(){
         document.title ="家长号码";
     }

     componentDidMount(){
         console.log('listState', this.props.listState)
         if (this.props.listState && !isObjEmpty(this.props.listState.listData)) {
             this.setState({
                 data: this.props.listState.listData,
                 isLoading: false,
             }, () => {
                 ReactDOM.findDOMNode(this.container).scrollTop = this.props.listState.scrollTop
             })
             mPageIndex = this.props.listState.pageIndex
         } else {
             // Toast.loading('数据加载中...', 0)
             mPageIndex = 0
             this.loadMorePhone();
         }
     }

     render(){
         return <div style={{background: '#F2F2F2'}}>
             <RefreshLayout
                 refreshing={this.state.isRefreshing}
                 ref={el => {
                     this.container = el
                 }}
                 onRefresh={this.loadMorePhone}>
                 {
                     this.state.data.length > 0 ?
                         this.state.data.map((itemdata,index) =>  <PhoneInfoItem itemdata={itemdata} role={this.state.role} index = {index}></PhoneInfoItem>)
                         :
                         <List dataSource={this.state.data}
                             renderItem={(itemdata,index) =>(
                                 <List.Item>
                                     <PhoneInfoItem itemdata={itemdata} role={this.state.role} index = {index}></PhoneInfoItem>
                                 </List.Item>
                             )}/>
                 }
             </RefreshLayout>
             <Icon type="plus-circle" theme='filled' className='common-add-icon' onClick={this.onAddAction} />
         </div>
     }

     loadMorePhone=()=> {
         let userPhone = this.props.userInfo.user.userPhone;
         mPageIndex++;
         try {
             this.setState({
                 isRefreshing: true
             })
         } catch (e) {
         }
         fetchPost(API.leaveListPhone, {
             stuId: this.props.userInfo.user.student.stuId,
             pageIndex:mPageIndex,
             pageSize: this.state.pageSize
         }).then((response) => {
             if(response.data.length>0){
                 for (let i = 0; i < response.data.length; i++) {
                     let model = {
                         id:response.data[i].id,
                         name: response.data[i].name,
                         phone: response.data[i].phone,
                         relation: response.data[i].relation,
                         schoolId: response.data[i].schoolId,
                         stuId: response.data[i].stuId,
                         stuName: response.data[i].stuName,
                         userPhone: userPhone
                     };
                     this.state.data.push(model);
                 }
                 this.setState({
                     data: this.state.data
                 })
             }else{

             }
             this.setState({
                 isRefreshing: false,
                 isLoading: false
             })
         }).catch((error) => {
             console.log("error:" + JSON.stringify(error));
             this.setState({
                 isRefreshing: false,
                 isLoading: false
             })
             Toast.info(error, 2)
         })

     }
     onAddAction=()=>{
         this.props.history.push("/phoneAdd/");
     }

 }


 let mapStateToProps = (state) => ({
     userInfo: {...state.redUserInfo},
     listState: {...state.redListState}
 })

 let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PhoneInfo)